export const INTERPRETER_LANGUAGE_SELECTED =
  "INTERPRETER::INTERPRETER_LANGUAGE_SELECTED";
export const INTERPRETER_GENDER_SELECTED =
  "INTERPRETER::INTERPRETER_GENDER_SELECTED";
export const INTERPRETER_CALL_TYPE_SELECTED =
  "INTERPRETER::INTERPRETER_CALL_TYPE_SELECTED";

export const INTERPRETER_LANGUAGE_UPDATED =
  "INTERPRETER::INTERPRETER_LANGUAGE_UPDATED";
export const INTERPRETER_INVITE_STATUS =
  "INTERPRETER::INTERPRETER_INVITE_STATUS";
export const INTERPRETER_INVITE_REQUEST_ID =
  "INTERPRETER::INTERPRETER_INVITE_REQUEST_ID";
export const INTERPRETER_INVITE_NOTIFICATION_ID =
  "INTERPRETER::INTERPRETER_INVITE_NOTIFICATION_ID";
export const INTERPRETER_INVITE_RETRY_NOTIFCATION_ID =
  "INTERPRETER::INTERPRETER_INVITE_RETRY_NOTIFCATION_ID";
export const INTERPRETER_GENDER_OPTION_UPDATED =
  "INTERPRETER::INTERPRETER_GENDER_OPTION_UPDATED";
export const INTERPRETER_CALL_TYPE_UPDATED =
  "INTERPRETER::INTERPRETER_CALL_TYPE_UPDATED";
export const INTERPRETER_ESTIMATED_TIME = "INTERPRETER_ESTIMATED_TIME";
